import { render } from "./YAxis.vue?vue&type=template&id=0d3be1cd"
import script from "./YAxis.vue?vue&type=script&lang=js"
export * from "./YAxis.vue?vue&type=script&lang=js"

import exportComponent from "/root/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__